// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"125":"component---src-pages-404-js","223":"commons","245":"component---src-pages-index-tsx"}[chunkId] + "-" + {"125":"7905cf5ba296fdfe4a7d","223":"310d03aa36a573e3adc8","245":"f30af4554fd5082840eb"}[chunkId] + ".js";
};